<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :colNum="{ index: 5, sinNum: 10 }"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            type="table-top-active"
            size="mini"
            @click="changeTable(item.focus)"
            >全部({{ totalNum }})</el-button
          >
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            @click="jumpNew"
            icon="icon-ccui-add-sup"
            >新增人员</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.userName"
            clearable
            searchLabel="姓名"
            placeholder="请输入姓名模糊查询"
          ></el-input>
          <el-select
            v-model="formData.sex"
            clearable
            placeholder="请选择性别查询"
            searchLabel="性别"
          >
            <el-option key="1" label="男" value="1"></el-option>
            <el-option key="2" label="女" value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="formData.birthday"
            type="date"
            searchLabel="出生日期"
            placeholder="请输入出生日期查询"
          ></el-date-picker>
          <el-select
            v-model="formData.politicalOutlook"
            clearable
            placeholder="请选择政治面貌查询"
            searchLabel="政治面貌"
          >
            <el-option
              v-for="item in politicalOutlookOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.isMarried"
            clearable
            placeholder="请选择婚姻状况查询"
            searchLabel="婚姻状况"
          >
            <el-option key="1" label="未婚" value="1"></el-option>
            <el-option key="2" label="已婚" value="2"></el-option>
            <el-option key="3" label="离异" value="3"></el-option>
            <el-option key="4" label="丧偶" value="4"></el-option>
          </el-select>
          <el-input
            v-model="formData.idNum"
            clearable
            searchLabel="身份证号"
            placeholder="请输入身份证号查询"
          ></el-input>
        </template>
        <!-- 表单高级搜索 -->
        <el-input
          v-model="formData.userName"
          clearable
          searchLabel="姓名"
          placeholder="请输入姓名模糊查询"
          slot="searchItem1"
          style="width:160px"
        ></el-input>
        <el-select
          v-model="formData.sex"
          clearable
          placeholder="请选择性别查询"
          searchLabel="性别"
          slot="searchItem2"
          style="width:160px"
        >
          <el-option key="1" label="男" value="1"></el-option>
          <el-option key="2" label="女" value="2"></el-option>
        </el-select>
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          searchLabel="出生日期"
          placeholder="请输入出生日期查询"
          slot="searchItem3"
          style="width:160px"
        ></el-date-picker>
        <el-select
          v-model="formData.politicalOutlook"
          clearable
          placeholder="请选择政治面貌查询"
          searchLabel="政治面貌"
          slot="searchItem4"
          style="width:160px"
        >
          <el-option
            v-for="item in politicalOutlookOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="formData.isMarried"
          clearable
          placeholder="请选择婚姻状况查询"
          searchLabel="婚姻状况"
          slot="searchItem5"
          style="width:160px"
        >
          <el-option key="1" label="未婚" value="1"></el-option>
          <el-option key="2" label="已婚" value="2"></el-option>
          <el-option key="3" label="离异" value="3"></el-option>
          <el-option key="4" label="丧偶" value="4"></el-option>
        </el-select>
        <el-input
          v-model="formData.idNum"
          clearable
          searchLabel="身份证号"
          slot="searchItem6"
          placeholder="请输入身份证号查询"
          style="width:260px"
        ></el-input>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-if="tableHack"
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="setRowClass"
        :cell-style="setStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="setTableTitleWidth"
        @sort-change="changeSort"
        max-height="20000"
      >
        <el-table-column type="selection" width="28" />
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :type="table.type"
            :key="index"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :filter-method="filterMethodList[table.filterMethodName]"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </template>

        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpDetail(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}</el-checkbox
                >
                <div class="ccui-popover-line"></div>
                <draggable
                  :list="unfixedTableThead"
                  class="ccui-draggable"
                  @change="handleTableChange"
                >
                  <el-checkbox-group
                    v-for="(item, index) in unfixedTableThead"
                    v-model="item.checked"
                    :key="index"
                  >
                    <el-checkbox
                      :label="item"
                      :checked="item.checked"
                      :width="item.width"
                      :title="item.label"
                      @change="handleUpdate(item, index)"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </draggable>
                <i
                  class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                  slot="reference"
                ></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div class="ccui-operation">
          <el-button
            v-show="isSelection"
            size="mini"
            type="default"
            @click="handleDelSelected"
            style="margin-right:10px"
            >批量删除</el-button
          >
          <el-export-button
            placement="bottom"
            @export-excel="handleExport"
            @export-pdf="handleExport('all')"
          ></el-export-button>
        </div>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="pageNoCode"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import draggable from "vuedraggable";
import { removeUser, getpeoplemanageList } from "../api/item-list";
import { setSessionItem, getSessionItem, ishasAgentId } from "@/basa/utils";
export default {
  name: "peoplemanage-single-tab-item-list",
  components: {
    draggable
  },
  data() {
    return {
      workStatus: "",
      // 表格数据
      tableData: [],
      tableHack: true,
      // 表格命名
      tableName: this.tableList.peoplemanageItemListAll,
      // 表格数据
      tableThead: [],
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: "38",
          checked: true,
          fixed: true,
          type: "index"
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "姓名",
          prop: "userName",
          width: "62",
          checked: true
        },
        {
          label: "性别",
          prop: "sex",
          width: "60",
          checked: true,
          formatterName: "sexHandler"
        },
        {
          label: "出生日期",
          prop: "birthday",
          width: "120",
          checked: true,
          formatterName: "birthdayFormat"
        },
        {
          label: "年龄",
          prop: "age",
          width: "60",
          checked: true
        },
        {
          label: "身份证号",
          prop: "idNum",
          width: "160",
          checked: true,
          formatterName: "idNumHandle"
        },
        {
          label: "手机号",
          prop: "userMobile",
          width: "120",
          checked: true,
          formatterName: "userMobileHandle"
        },
        {
          label: "政治面貌",
          prop: "politicalOutlook",
          width: "70",
          checked: true,
          formatterName: "outlookHandler"
        },
        {
          label: "婚姻状况",
          prop: "isMarried",
          width: "70",
          checked: true,
          formatterName: "ismarriedHandler"
        },
        {
          label: "籍贯",
          prop: "nativeplace",
          width: "138",
          checked: true,
          formatterName: "nativeplaceHandler"
        },
        {
          label: "毕业院校",
          prop: "finishSchool",
          width: "120",
          checked: true
        },
        {
          label: "所在部门",
          prop: "departmentId",
          width: "136",
          checked: true
        },
        {
          label: "是否在编",
          prop: "isPrep",
          width: "70",
          checked: true,
          formatterName: "isPrepHandler"
        }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      popoverShow: false,
      selectRow: [],
      selectData: [],
      // 高级搜索数据 start
      // 高级搜索提交数据
      isShowSearch: true,
      formData: {
        userName: "",
        sex: "",
        birthday: "",
        politicalOutlook: "",
        isMarried: "",
        idNum: ""
      },
      formDataSearch: "",
      politicalOutlookOptions: [
        {
          label: "群众",
          value: "1"
        },
        {
          label: "团员",
          value: "2"
        },
        {
          label: "党员",
          value: "3"
        }
      ],
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 分页相关
      totalNum: null,
      pageNoCode: 1,
      pageSizeCode: this.getLocalPageSize(),
      // 删除相关
      isSelection: false,
      typeDel: "",
      delDemoId: "",
      content: "您确定要删除吗？",
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 全选相关
      isIndeterminate: false,
      checkAll: false,
      // 筛选字段调用函数集合
      filterMethodList: {
        filterHandler: (value, row, column) => {
          const property = column["property"];
          return row[property] === value;
        }
      },
      // 表格数据相关处理
      formatterList: {
        sexHandler(row, col) {
          switch (row.sex) {
            case 1:
              return "男";
            case 2:
              return "女";
          }
        },
        ismarriedHandler(row, col) {
          switch (row.isMarried) {
            case 1:
              return "未婚";
            case 2:
              return "已婚";
            case 3:
              return "离异";
            case 4:
              return "丧偶";
          }
        },
        outlookHandler(row, col) {
          switch (row.politicalOutlook) {
            case 1:
              return "群众";
            case 2:
              return "团员";
            case 3:
              return "党员";
          }
        },
        nativeplaceHandler(row, col) {
          let nativeplace = `${row.receiveProvince}${row.receiveCity}${row.receiveCounty}${row.receiveTowns}`;
          return nativeplace;
        },
        birthdayFormat(row, col) {
          return row.birthday ? row.birthday.substr(0, 10) : "";
        },
        userMobileHandle(row) {
          var reg = /(\d{3})\d{4}(\d{4})/;
          return row.userMobile
            ? (row.userMobile = row.userMobile.replace(reg, "$1****$2"))
            : (row.userMobile = "");
        },
        idNumHandle(row) {
          var reg = /(\d{6})(\d+)(\d{3}[0-9xX])/;
          return row.idNum
            ? (row.idNum = row.idNum.replace(reg, "$1********$3"))
            : (row.idNum = "");
        },
        isPrepHandler(row) {
          switch (row.isPrep) {
            case 0:
              return "否";
            case 1:
              return "是";
          }
        }
      }
    };
  },
  mounted() {
    this.setInitData();
  },
  watch: {
    selectData(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item));
        });
      }
    }
  },
  methods: {
    setInitData() {
      this.setBreadcrumb();
      this.setTableWidth();
      this.renderTable();
    },
    // 导出
    async handleExport(type) {
      let sexObj = {
        1: "男",
        2: "女"
      };
      let politicalOutlookobj = {
        1: "群众",
        2: "团员",
        3: "党员"
      };
      let isMarriedobj = {
        1: "未婚",
        2: "已婚",
        3: "离异",
        4: "丧偶"
      };

      let isPrep = {
        0: "否",
        1: "是"
      };
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("第一页");
      const page1Row1 = ws1.addRow([
        "序号",
        "姓名",
        "性别",
        "出生日期",
        "年龄",
        "身份证号",
        "手机号",
        "政治面貌",
        "婚姻状况",
        "籍贯",
        "毕业院校",
        "所在部门",
        "是否在编"
      ]);
      if (type === "all") {
        let res = await getpeoplemanageList({
          pageNo: 1,
          userName: "",
          pageSize: 5000,
          sortprop: "",
          sortord: "",
          isDelete: 0
        });

        if (res.data.data.rows.length > 0) {
          res.data.data.rows.forEach((item, index) => {
            let nativeplace = `${item.receiveProvince}${item.receiveCity}${item.receiveCounty}${item.receiveTowns}`;
            ws1.addRow([
              index + 1,
              item.userName,
              sexObj[item.sex],
              item.birthday ? item.birthday.substr(0, 10) : "",
              item.age,
              item.idNum
                ? item.idNum.replace(
                    /(\d{6})(\d+)(\d{3}[0-9xX])/,
                    "$1********$3"
                  )
                : "",
              item.userMobile
                ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
                : "",
              politicalOutlookobj[item.politicalOutlook],
              isMarriedobj[item.isMarried],
              nativeplace,
              item.finishSchool,
              type === "all"
                ? item.departmentId
                  ? JSON.parse(item.departmentId)[0].abbrName
                  : ""
                : item.departmentId,
              isPrep[item.isPrep]
            ]);
          });
        }
      } else {
        this.tableData.forEach((item, index) => {
          let nativeplace = `${item.receiveProvince}${item.receiveCity}${item.receiveCounty}${item.receiveTowns}`;
          ws1.addRow([
            index + 1,
            item.userName,
            sexObj[item.sex],
            item.birthday ? item.birthday.substr(0, 10) : "",
            item.age,
            item.idNum
              ? item.idNum.replace(/(\d{6})(\d+)(\d{3}[0-9xX])/, "$1********$3")
              : "",
            item.userMobile
              ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              : "",
            politicalOutlookobj[item.politicalOutlook],
            isMarriedobj[item.isMarried],
            nativeplace,
            item.finishSchool,
            type === "all"
              ? item.departmentId
                ? JSON.parse(item.departmentId)[0].abbrName
                : ""
              : item.departmentId,
            isPrep[item.isPrep]
          ]);
        });
      }
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "userName", width: 10 },
        { key: "sex", width: 8 },
        { key: "birthday", width: 20 },
        { key: "age", width: 8 },
        { key: "idNum", width: 20 },
        { key: "userMobile", width: 20 },
        { key: "politicalOutlook", width: 10 },
        { key: "isMarried", width: 10 },
        { key: "nativeplace", width: 30 },
        { key: "finishSchool", width: 20 },
        { key: "departmentId", width: 20 },
        { key: "isPrep", width: 10 }
      ];
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "人员信息.xlsx");
    },
    // 导出 end
    // popoverClose() {
    //   this.popoverShow = false;
    // },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    setStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    setTableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.tableHack = false;
      this.$nextTick(() => {
        this.tableHack = true;
      });
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    setRowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    // 跳转编辑
    jumpEdit(index, row) {
      this.$router.push(
        "/list-query/peoplemanageSingleTab/edit-item/" + row.id
      );
    },
    // 跳转详情
    jumpDetail(index, row) {
      this.$router.push(
        `/list-query/peoplemanageSingleTab/item-detail/${row.id}/${index}`
      );
    },
    // 跳转新增
    jumpNew() {
      this.$router.push("/list-query/peoplemanageSingleTab/new-item");
    },
    // 删除列表数据
    handleDelete(index, row) {
      // this.dialogVisible = true;
      this.deleteLog();
      this.delDemoId = row.id;
    },
    // 删除弹框
    deleteLog() {
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      }).then(() => {
        if (this.typeDel == "all") {
          this.delPeople(this.idArrSelected);
        } else {
          this.delPeople([this.delDemoId]);
        }
      });
      // .catch(() => {
      //   console.log("取消删除");
      // });
    },
    // 批量删除并刷新列表
    handleDelSelected() {
      if (this.idArrSelected) {
        this.typeDel = "all";
        this.deleteLog();
      } else {
        this.$message({
          message: "请选择您要删除的数据",
          type: "warning"
        });
      }
    },
    // 分页
    // 上一页
    handlePrev() {},
    // 下一页
    handleNext() {},
    //  显示条数更改
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
        setSessionItem("pageSize", this.tableName, val);
      }
      this.getpeoplemanageList(this.formDataSearch);
    },
    // 获取默认条数
    getLocalPageSize() {
      return (
        getSessionItem("pageSize", this.tableList.peoplemanageItemListAll) || 20
      );
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getpeoplemanageList(this.formDataSearch);
    },
    // 分页 end
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    searchItem(searchData) {
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.getpeoplemanageList(this.formDataSearch);
    },
    // 高级搜索 end
    // 数据请求
    getpeoplemanageList(reqObj) {
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNoCode;
      obj.workStatus = this.workStatus;
      obj.isDelete = 0;
      obj.isShowPageLoading = true;
      obj.workStatus = this.workStatus;
      obj.isDelete = 0;
      obj.isShowPageLoading = true;
      getpeoplemanageList(obj).then(res => {
        this.isShowPagination = res.data.data.recordsTotal > 0;
        this.tableData = res.data.data.rows;
        this.totalNum = res.data.data.recordsTotal;
        this.pageNoCode = res.data.data.pageNo; // 当前页
        this.tableData.forEach((i, index) => {
          i.departmentId = i.departmentId
            ? JSON.parse(i.departmentId)[0].abbrName
            : "";
        });
      });
    },
    // 删除请求
    delPeople(arr) {
      removeUser({
        ids: arr,
        isShowLoading: true
      }).then(res => {
        this.$message({
          message: "删除成功",
          type: "success",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.$refs.multipleTable.tableData.length <= 1 && --this.pageNoCode;
        this.getpeoplemanageList();
        this.isSelection = false;
      });
    },
    // 全选、多选选择
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true;
      } else if (val.length === 2) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    // 排序
    changeSort(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getpeoplemanageList();
    },
    // 页签跳转
    changeTable(data) {
      this.$router.push({ name: `peoplemanage-tab-item-list-${data}` });
    },
    setBreadcrumb() {
      this.$store.dispatch("setBreadcrumb", [
        {
          level: "level2",
          data: {
            name: "主子表增删改查",
            path: "/list-query/peoplemanageSingleTab/item-list-all"
          }
        },
        {
          level: "level3",
          data: {
            name: "",
            path: ""
          }
        }
      ]);
    }
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.parent.componentInstance.cache) {
      delete this.$vnode.parent.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  },
  activated() {
    this.getpeoplemanageList(this.formDataSearch);
  }
};
</script>
